module.exports = __webpack_public_path__ + "img/bed-front.4889490c.svg";